module.exports = __webpack_public_path__ + "img/o_1dr87ok0a1jia16u415aasgh1fsv9.0dc9480e.png";